import React, { useState } from 'react';
import { FullscreenControl, Map, ZoomControl } from 'react-yandex-maps';
import MuiModal from '../../atoms/MuiModal';
import { StyledPickLocationModal } from './PickLocationModal.style';
import { HiLocationMarker } from 'react-icons/hi';
import { useThrottle } from '@/Hooks/useThrottle';
import { TODO_ANY } from '@/Types/CommonTypes';
import { SxProps, Theme } from '@mui/material';
import { useIsMobile } from '@/Hooks/useIsMobile';
import BaseButton from '@/Components/atoms/BaseComponents/BaseButton';
import { useTranslation } from 'next-i18next';
import { logger } from '@/Services/Logger';

type Props = {
  open: boolean;
  defaultCoords: { lat: number, long: number };
  onSelect: (lat: number, long: number) => void;
  onClose: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
  mapStyle?: React.CSSProperties;
  modalSx?: SxProps<Theme>;
  zoom?: number;
}

const PickLocationModal = ({ open, onSelect, defaultCoords, mapStyle, onClose, modalSx, zoom = 15 }: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [coords, setCoords] = useState<{
    user_lat: number;
    user_lang: number;
  }>({
    user_lat: defaultCoords.lat,
    user_lang: defaultCoords.long,
  });
  const throttledCoords = useThrottle(coords, 250);

  const onDrag = (event: TODO_ANY) => {
    const _coords = event?.originalEvent?.map?.getCenter?.();
    if(_coords[0] !== coords.user_lat || _coords[1] !== coords.user_lang) {
      setCoords({
        user_lat: _coords[0],
        user_lang: _coords[1],
      })
    }
  };

  const onKeyDownModal: React.KeyboardEventHandler<HTMLDivElement> = (event) => {
    logger.log('event.key', event.key);
    
    if(event.key === 'Enter') {
      onSelect(coords.user_lat, coords.user_lang);
    };
  }


  return (
    <MuiModal open={open} keepMounted onKeyDown={onKeyDownModal} onClose={onClose} sx={{
      ...(isMobile ? {
        '.MuiPaper-root': {
          border: '0 !important',
          margin: 0,
        },
        '.MuiDialogContent-root': {
          padding: '0 !important',
        }
      } : {}),
      ...modalSx
    }}>
      <StyledPickLocationModal style={{ maxWidth: '500px', width: '100%', height: '300px' }}>
        <Map
          defaultState={{ center: [throttledCoords.user_lat, throttledCoords.user_lang],  zoom: zoom }}
          width={'100%'}
          height={'100%'}
          onMouseMove={onDrag}
          style={mapStyle}
        >
          <FullscreenControl />
          <ZoomControl />
        </Map>
        <div className='coords-location-marker'>
          <HiLocationMarker className='coords-location-marker__svg' color={'red'} size={50} />
        </div>
        <div className='coords-location-select'>
          <BaseButton className='coords-location-select__btn' onClick={() => onSelect(coords.user_lat, coords.user_lang)}>
            { t('confirm_location') }
          </BaseButton>
        </div>
      </StyledPickLocationModal>
    </MuiModal>
  )
}

export default PickLocationModal;
